import { Form, Input } from 'antd';

import Button from '../../Atoms/Button/Button';
const { TextArea } = Input;

const ScriptCampaing = () => {

  // Enviar / Crear Script
  const sendForm = (e) => {
    console.log(e) // Aqui los datos(Script)
  }

  return (
    <div className="box mt-30 s-pxy-20 m-pxy-50">
      <div className="">
        <p className="source-24 mb-15">Script de la campaña</p>
        <p className="source-16 mb-15">Introduzca el script de la campaña (máximo de 1000 caracteres)</p>
        <Form onFinish={sendForm} >
          <Form.Item name="script" rules={[{required: true, message: "Introduzca el script de la campaña:"}]}>
            <TextArea showCount rows={8} maxLength={1000} placeholder="Escriba o pegue aquí tu texto script" />
          </Form.Item>
          <div className={`buttons-container mt-30`}>
            <Button content="Guardar" type="primary"></Button>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default ScriptCampaing
